<template>
  <div>
    <CRow>
      <CCol col="5">
        <b-form-group :label="$store.state.form.periode" label-for="periode" class="my-0">
          <Multiselect
            id="periode"
            v-model="filter.periode"
            :options="listPeriodeGaji"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="-- Pilih Periode --"
            label="namaPeriode"
            track-by="id"
            @input="hitungTanggal()"
          ></Multiselect>
        </b-form-group>
      </CCol>
      <CCol col="5">
        <b-form-group :label="$store.state.form.bulanTahun" label-for="bulanTahun" class="my-0">
          <date-picker id="bulanTahun" type="month" format="MMMM - YYYY" style="width: 100%" v-model="filter.bulanTahun" @input="hitungTanggal()"></date-picker>
        </b-form-group>
      </CCol>
      <CCol col="2" style="margin-bottom: 6px">
        <div class="w-100 h-100 d-flex align-items-end">
          <b-button variant="danger" style="" class="d-block w-100" v-c-tooltip.hover.click="'Reset'" @click="reset()">{{ $store.state.form.reset }}</b-button>
        </div>
      </CCol>
      <CCol col="12" class="">
        <small class="mx-2">{{ $moment(filter.tglAwal).format("LL") }} - {{ $moment(filter.tglAkhir).format("LL") }} ( {{ filter.jmlHari }} hari)</small>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="12" md="12" lg="12" class="mt-2">
        <h4>
          <strong>{{ $store.state.form.absensiKedatangan }}</strong>
        </h4>
        <hr />
      </CCol>
    </CRow>

    <CRow>
      <CCol col="12" md="12" lg="12">
        <CDataTable :items="items" :fields="fields" responsive sorter hover show-empty :loading="tableBusy">
          <template #actions="{ item }">
            <td>
              <b-button
                v-b-modal.modal-foto
                @click="
                  src1 = item.fotoAbsensi ? viewImage(item.fotoAbsensi) : null;
                  src2 = item.fotoAbsensiKeluar ? viewImage(item.fotoAbsensiKeluar) : null;
                "
              >
                Foto
              </b-button>
            </td>
          </template>
          <template #statusIjin="{ item }">
            <td>
              <span v-if="item.statusIjin == 0">{{ $store.state.form.berangkat }}</span>
              <span v-else-if="item.statusIjin == 1">{{ $store.state.form.cuti }}</span>
              <span v-else-if="item.statusIjin == 2">{{ $store.state.form.dinas }}</span>
              <span v-else-if="item.statusIjin == 3">{{ $store.state.form.cutiHamil }}</span>
              <span v-else-if="item.statusIjin == 4">{{ $store.state.form.ijin }}</span>
              <span v-else-if="item.statusIjin == 5">{{ $store.state.form.sakit }}</span>
              <span v-else-if="item.statusIjin == 6">{{ $store.state.form.alpha }}</span>
              <span v-else-if="item.statusIjin == 7">{{ $store.state.form.keluargaMeninggal }}</span>
              <span v-else-if="item.statusIjin == 8">{{ $store.state.form.istriMelahirkan }}</span>
              <span v-else-if="item.statusIjin == 9">{{ $store.state.form.menikah }}</span>
              <span v-else-if="item.statusIjin == 10">{{ $store.state.form.jatahLibur }}</span>
            </td>
          </template>
          <template #createdAt="{ item }">
            <td>
              <div v-if="item.statusIjin == 0">
                {{ $moment(item.createdAt).format("ll") }}
              </div>
              <div v-else>{{ $moment(item.tglIjin).format("ll") }}</div>
            </td>
          </template>
        </CDataTable>
      </CCol>
    </CRow>

    <div>
      <b-modal id="modal-foto" size="lg" centered scrollable :title="$store.state.modal.fotoAbsensi" header-bg-variant="success" header-text-variant="light">
        <CRow>
          <CCol>
            <h5 class="text-center mb-2">{{ $store.state.modal.fotoAbsen }}</h5>
          </CCol>
        </CRow>

        <CRow v-if="src1">
          <CCol class="text-center">
            <img :src="src1" alt="foto absen masuk" style="max-width: 300px; max-height: 300px" />
            <div><small>Foto Masuk</small></div>
          </CCol>
        </CRow>

        <CRow v-if="src2" class="mt-3">
          <CCol class="text-center">
            <img :src="src2" alt="foto absen keluar" style="max-width: 300px; max-height: 300px" />
            <div><small>Foto Pulang</small></div>
          </CCol>
        </CRow>

        <template #modal-footer>
          <b-button variant="secondary" @click="$bvModal.hide('modal-foto')">
            {{ $store.state.form.batal }}
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabAbsensiKedatangan",
  props: ["data", "activeTab"],
  data() {
    return {
      listPeriodeGaji: [],
      filter: {
        periode: null,
        bulanTahun: null,
        tglAwal: null,
        tglAkhir: null,
        jmlHari: "0",
        dataKaryawanId: this.$route.query.dataKaryawanId,
      },
      src1: "",
      src2: "",
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          sorter: true,
          _classes: "table-number text-center",
        },
        {
          key: "tanggalClock",
          label: "Tanggal",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "statusIjin",
          label: "Status Absensi",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "namaMasuk",
          label: "Jam Masuk",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "namaKeluar",
          label: "Jam Pulang",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "actions",
          label: "Actions",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
      ],
      tableBusy: false,
    };
  },
  computed: {},
  watch: {
    async activeTab(newVal) {
      if (newVal === 1) {
        // this.getDataAsuransi();
        await this.getPeriodeGaji();
        await this.reset();
      }
    },
  },
  async mounted() {},
  methods: {
    viewImage(path) {
      const vm = this;
      if (!path) return null;

      if (vm.$be.includes("localhost")) {
        return vm.$be + path;
      } else if (vm.$store.state.kode_client) {
        return vm.$be + "api-" + vm.$store.state.kode_client + "/" + path;
      }
      return null;
    },
    async hitungTanggal() {
      const vm = this;
      if (!vm.filter.periode) vm.filter.periode = vm.listPeriodeGaji[0];
      const periode = vm.filter.periode;
      const monthYear = vm.$moment(vm.filter.bulanTahun).format("MM-YYYY");
      //set tanggal terakhir bulan
      const tanggalTerakhirBulan = vm.$moment(`${monthYear}`, "MM-YYYY").endOf("month").format("D");
      periode.xtanggalGajian = periode.tanggalGajian == -1 ? tanggalTerakhirBulan : periode.tanggalGajian;
      periode.xtanggalAwal = periode.tanggalAwal == -1 ? tanggalTerakhirBulan : periode.tanggalAwal;
      periode.xtanggalAkhir = periode.tanggalAkhir == -1 ? tanggalTerakhirBulan : periode.tanggalAkhir;
      //set tanggal default
      vm.filter.tglAwal = vm.$moment(`${periode.xtanggalAwal}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      vm.filter.tglAkhir = vm.$moment(`${periode.xtanggalAkhir}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      //jika tanggal awal adalah bulan sebelumnya (awal - akhir = 30 - 10)
      if (periode.xtanggalAwal > periode.xtanggalAkhir) {
        let tanggal = vm.$moment(`${monthYear}`, "MM-YYYY").subtract(1, "month");
        //jika xtanggalAwal adalah tanggal terakhir bulan
        let awal = periode.xtanggalAwal;
        /*
          jika tanggal awal = -1 (tanggal terakhir bulan) atau
          jika tanggal awal melebihi tanggal dalam bulan (bulan februari tetapi tanggal awal = 30, maka tanggal awal ikut 28 / tanggal akhir dalam bulan)
        */
        if (periode.tanggalAwal == -1 || periode.xtanggalAwal > vm.$moment(tanggal).endOf("month").format("D")) {
          awal = vm.$moment(tanggal).endOf("month").format("D");
        }
        vm.filter.tglAwal = vm.$moment(`${awal}-${tanggal.format("MM")}-${tanggal.format("YYYY")}`, "D-MM-YYYY").format("YYYY-MM-DD");
      } else {
        //jika tanggal awal melebihi tanggal dalam bulan (bulan februari tetapi tanggal awal = 30, maka tanggal awal ikut 28 / tanggal awal dalam bulan)
        if (periode.xtanggalAwal > tanggalTerakhirBulan) {
          vm.filter.tglAwal = vm.$moment(`${tanggalTerakhirBulan}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
        }
      }
      //jika tanggal akhir melebihi tanggal dalam bulan (bulan februari tetapi tanggal akhir = 30, maka tanggal akhir ikut 28 / tanggal akhir dalam bulan)
      if (periode.xtanggalAkhir > tanggalTerakhirBulan) {
        vm.filter.tglAkhir = vm.$moment(`${tanggalTerakhirBulan}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      }
      vm.filter.jmlHari = vm.$moment(vm.filter.tglAkhir).diff(vm.$moment(vm.filter.tglAwal), "Days") + 1;
      console.log("filter", vm.filter);
      vm.getDatas();
    },
    async getDatas() {
      let vm = this;
      let absensi = await vm.$axios.post("absensiKaryawanMobile/listKedatanganByDataKaryawanId", vm.filter);
      // console.log("absensi", absensi);
      vm.items =
        absensi.data.status == 200
          ? absensi.data.data.map((x, idx) => {
              return {
                ...x,
                no: idx + 1,
                namaMasuk: x.masuk || " - ",
                namaKeluar: x.keluar || " - ",
                tanggalClock: vm.$moment(x.tanggalAbsen).format("ll"),
              };
            })
          : [];
    },
    async getPeriodeGaji() {
      let vm = this;
      let listPeriodeGaji = await vm.$axios.post("periodeGajiMitra/list");
      // console.log('listPeriodeGaji : ', listPeriodeGaji)
      vm.listPeriodeGaji =
        listPeriodeGaji.data.status == 200
          ? listPeriodeGaji.data.data.map((x) => {
              x.namaTanggalGajian = x.tanggalGajian == -1 ? "akhir bulan" : "Tanggal " + x.tanggalGajian;
              x.namaTanggalAwal = x.tanggalAwal == -1 ? "akhir bulan" : x.tanggalAwal;
              x.namaTanggalAkhir = x.tanggalAkhir == -1 ? "akhir bulan" : x.tanggalAkhir;
              return {
                ...x,
                namaPeriode: `Gajian ${x.namaTanggalGajian} (Kerja ${x.namaTanggalAwal} - ${x.namaTanggalAkhir})`,
              };
            })
          : [];
    },
    async reset() {
      const vm = this;
      const month = vm.$moment().format("MM");
      const year = vm.$moment().format("YYYY");
      vm.filter.bulanTahun = new Date(vm.$moment(`01-${month}-${year}`, "DD-MM-YYYY"));
      vm.filter.periode = vm.listPeriodeGaji[0];
      this.hitungTanggal();
    },
  },
};
</script>
